/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiPushedMetaEventTypeFromJSON, ApiPushedMetaEventTypeToJSON, } from './ApiPushedMetaEventType';
export function ApiPushedMetaEventsFromJSON(json) {
    return ApiPushedMetaEventsFromJSONTyped(json, false);
}
export function ApiPushedMetaEventsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'blockedCount': !exists(json, 'blockedCount') ? undefined : json['blockedCount'],
        'conversionId': !exists(json, 'conversionId') ? undefined : json['conversionId'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'pushedCount': !exists(json, 'pushedCount') ? undefined : json['pushedCount'],
        'type': !exists(json, 'type') ? undefined : ApiPushedMetaEventTypeFromJSON(json['type']),
    };
}
export function ApiPushedMetaEventsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'blockedCount': value.blockedCount,
        'conversionId': value.conversionId,
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'id': value.id,
        'projectId': value.projectId,
        'pushedCount': value.pushedCount,
        'type': ApiPushedMetaEventTypeToJSON(value.type),
    };
}
